import type { ReactNode } from 'react';

export const symbol_steps: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M216-570q36 0 70 13.5t61 38.5l395 378h18q25.5 0 42.75-17.25T820-200q0-11.2-2.12-23.8-2.13-12.6-14.88-25.2L623-429l-76-227-92 23q-29 7-52-10.5T380-691v-97l-54-27-175 235q-2 2-3.5 4.5T144-570h72Zm0 60h-78q3 11 9 20.18 6 9.17 14 16.82l338 307q14 13 31 19.5t36 6.5h89L306-474q-18-17-41.45-26.5Q241.09-510 216-510ZM566-80q-30 0-57-11t-50-31L134-417q-46-42-51.5-103T114-631l154-206q17-23 45.5-30.5T368-861l28 14q21 11 32.5 30t11.5 42v84l74-19q30-8 58 7.5t38 44.5l65 196 170 170q20 20 27.5 43t7.5 49q0 50-35 85t-85 35H566Z"
		/>
	</svg>
);
